import * as yup from 'yup';
import { sharedCaravelaFields } from '../shared/sharedCaravelaSchema';

export const carCaravelaSchemaBuilder = (
    firstDriverAdditionalPremiumAge,
    secondDriverAdditionalPremiumAge,
    firstDriverAdditionalPremiumLicenseYears,
    secondDriverAdditionalPremiumLicenseYears,
    legalEntity,
    secondDriver,
    discountEntity,
    vehicleType
) => yup.object({
    ...sharedCaravelaFields(
        firstDriverAdditionalPremiumAge,
        secondDriverAdditionalPremiumAge,
        firstDriverAdditionalPremiumLicenseYears,
        secondDriverAdditionalPremiumLicenseYears,
        legalEntity,
        secondDriver,
        discountEntity,
        vehicleType
    ),
});

export default carCaravelaSchemaBuilder;
